<template>
  <div class="ba-neu-button" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
    <button :class="{ active: active, 'keep-active': keepActive, 'keep-pressed': keepPressed, hasHover: iconHover }"
            :disabled="disabled"
            :style="{ background: background }"
            @click="onClick" >
        <i v-if="icon" class="icon default" :class="setIcon"/>
        <i v-if="iconHover || keepPressed" class="icon hover" :class="iconHover"/>
        <i v-if="iconActive || keepActive" class="icon active" :class="iconActive"/>
        <span v-if="!hideLabel" class="text" :class="{ hasIcon: icon }"><slot/></span>
    </button>
  </div>
</template>

<script>

export default {
  name: 'BaNeuButton',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    keepActive: {
      type: Boolean,
      default: false
    },
    keepPressed: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      required: false
    },
    iconActive: {
      type: String,
      required: false
    },
    iconHover: {
      type: String,
      required: false
    },
    color: {
      type: String,
      required: false
    },
    colorActive: {
      type: String,
      required: false
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: null
    }
  },
  computed: {
    background () {
      if (this.active) {
        return this.colorActive || null
      }
      return this.color || null
    },
    setIcon () {
      return this.active ? this.icon : `${this.icon}-gray`
    }
  },
  data () {
    return {
      position: {},
      showTooltip: false
    }
  },
  mounted () {
    this.onMouseLeave()
  },
  methods: {
    onClick (event) {
      if (this.disabled) {
        return
      }
      this.$emit('click', event)
    },
    onMouseEnter () {
      if (!this.tooltip) return
      this.position = this.$el.getBoundingClientRect()
      const tooltip = document.createElement('span')
      tooltip.classList.add('bnb-tooltip', 'top')
      tooltip.style.position = 'fixed'
      tooltip.style.top = this.position.top + this.position.height + 10 + 'px'
      tooltip.style.left = this.position.left + this.position.width * 0.5 + 'px'
      tooltip.innerHTML = this.tooltip
      document.body.append(tooltip)
    },
    onMouseLeave () {
      const tooltips = document.querySelectorAll('.bnb-tooltip')
      if (!tooltips) return
      tooltips.forEach(item => item.remove())
    }
  }
}
</script>

<style lang="scss">
.ba-neu-button {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  button {
    display: inline-block;
    vertical-align: middle;
    border-radius: 5px;
    //height: 32px;
    min-width: 32px;
    padding: 7px;
    transition: background-color 0.2s ease,
                box-shadow 0.2s ease,
                opacity 0.2s ease;
    z-index: 2;
    overflow: visible;

    border-radius: 5px;
    background-color: #ddd;
    box-shadow: -1px -1px 3px 0px rgba(255, 255, 255, 0.75), 1px 1px 3px 0px rgba(0, 0, 0, 0.25);

    .icon {
      //position: absolute;
      //top: 8px;
      //left: 8px;
      //width: 16px;
      //height: 16px;
      background-size: cover;
      background-position: center center;
      vertical-align: middle;
      opacity: 1;
      transition: opacity 0.2s ease;
    }

    .text {
      display: block;
      line-height: 20px;
      vertical-align: middle;
      color: #767676;
      font-size: 12px;
      margin-top: -2px;
      transition: color 0.2s ease;

      &.hasIcon {
        margin-left: 20px;
      }
    }

    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }

    &:not(:disabled) {
      &:hover,
      &.keep-active {
        // background-color: #efefef;
        z-index: 3;

        .text {
          color: #444444;
        }
      }
    }

    &.hasHover:not(:disabled):hover {
      .icon.default {
        opacity: 0;
      }

      .icon.hover {
        opacity: 1;
      }
    }

    &.active,
    &:active:not(:disabled),
    &.keep-pressed:not(:disabled) {
      background-color: #e9e9e9;
      box-shadow: 1px 1px 2px 0px rgba(0, 0, 0, 0.35) inset, -1px -1px 2px 0px rgba(255, 255, 255, 0.85) inset;
      //box-shadow: inset -1px -1px 2px 0px rgba(255, 255, 255, 0.85), inset 1px 1px 2px 0px rgba(0, 0, 0, 0.5);
      z-index: 1;
      .text {
        color: #ffffff !important;
      }
    }
  }

}
.bnb-tooltip {
  position: absolute;
  min-width: 80px;
  text-align: center;
  top: calc(100% + 10px);
  left: 50%;
  transform: translate(-50%, 0);
  padding: 7px 12px;
  font-size: 13px;
  line-height: 19px;
  z-index: 99999999999;
  color: #444;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.16);
  border-radius: 6px;
  box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.16);
  background-clip: padding-box;
  &:before {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translate(-50%, 5px) rotate(45deg);
    width: 10px;
    height: 10px;
    border: 1px solid rgba(0, 0, 0, 0.16);
    background-color: #fff;
    border-right-width: 0;
    border-bottom-width: 0;
    background-clip: padding-box;
  }
}
// transition
.slide-fade-leave-active {
  transition: all 250ms cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter-active {
  transition: all 250ms ease;
}
.bottom {
  &.slide-fade-enter, &.slide-fade-leave-to {
    opacity: 0;
    transform: translate(-50%, 10px);
  }
}
.top {
  &.slide-fade-enter, &.slide-fade-leave-to {
    opacity: 0;
    transform: translate(-50%, -10px);
  }
}

</style>
